import React, { useContext, useEffect, useState } from "react";
import { RestaurantContext } from "../../../../../../contexts/Restaurant";
import { SettingsContext } from "../../../../../../contexts/Settings";
import { useParams, useHistory } from "react-router-dom";
import { useFilteredFloorWaiters } from "./useFilteredFloorWaiters";
import {
  getSystemSettings,
} from "../../../../../../functions/Functions";
import { toast } from "react-toastify";

const useTableFunctions = ({
  buttonDisabled,
  selectedDeptTag,
  selectedDeliveryType,
  selectedParty,
  setOrderDetails,
  orderDetails,
  setModal10Show,
  selectTable,
  setSelectTable,
  tableId,
  setTableId,
  guestSelected,
  setGuestSelected,
}) => {
  const {
    tableLoading,
    tableForSearch,
    //pagination
  } = useContext(RestaurantContext);
  let history = useHistory();

  const { generalSettings } = useContext(SettingsContext);
  const { order_id } = useParams();

  // const {
  //     t,
  //     buttonDisabled,
  //     selectedDeptTag,
  //     selectedDeliveryType,
  //     selectedParty,
  //     setOrderDetails,
  //     orderDetails,
  //     history,
  //     setModal10Show,
  //     selectTable,
  //     setSelectTable,
  //     tableId,
  //     setTableId,
  //     guestSelected,
  //     setGuestSelected,
  // } = usePosLogics();

  // const {
  //     buttonDisabled,
  //     selectedDeptTag,
  //     selectedDeliveryType,
  //     selectedParty,
  //     setOrderDetails,
  //     orderDetails,
  //     setModal10Show,
  //     selectTable,
  //     setSelectTable,
  //     tableId,
  //     setTableId,
  //     guestSelected,
  //     setGuestSelected,
  // } = usePosLogics();

  const colorPallete = [
    "#f3eabc",
    "#ffc7c7",
    "#c0ebe9d1",
    "#edf93278",
    "#C1E6FD",
    "#14ffff4d",
    "#ca26ff63",
    "#f9ad006b",
  ];
  const {
    waiters,
    setWaiters,
    waiterSelected,
    setWaiterSelected,
    getTableFloor,
    tablefloor,
    setTableFloor,
  } = useFilteredFloorWaiters(orderDetails);
  const [multiSelect, setMultiSelect] = useState(false);
  const [tables, setTables] = useState([]);
  const [tablesApi, setTableApi] = useState([]);
  const [tempIndex, setTempIndex] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const [newtable, setNewTable] = useState(null);
  const waitersList = waiters?.searchedWaiter || waiters?.waiterList;
  //get table with api
  useEffect(() => {
    if (tableForSearch && orderDetails.branch) {
      let getTableStatus = tableForSearch && Array.isArray(tableForSearch) &&
        tableForSearch.filter((tableSearch) => {
          const tableActive = parseInt(tableSearch.branch_id) === parseInt(orderDetails.branch?.id) &&
            parseInt(tableSearch.status) === 1;

          if(tableActive){
            const colorIndex = tableSearch?.is_color && colorPallete.findIndex(
              (color) => color === tableSearch.is_color
            );
            if (colorIndex !== "" && colorIndex !== -1) {
              colorPallete.splice(colorIndex, 1);
            }
          }
          return (
            tableActive
          );
        });

      if (!buttonDisabled) {
        setTables(getTableStatus);
        setTableApi(getTableStatus);
      }

      if (order_id && getTableStatus) {
        const newTable = [...getTableStatus];
        let selectedTable = {};
        let tabel =
          orderDetails.table &&
          orderDetails.table?.forEach((table) => {
            if (getTableStatus && getTableStatus?.length > 0) {
              const index = getTableStatus.findIndex(
                (tableIndex) => table?.id === tableIndex.id
              );
              newTable[index] && setTempIndex(index);
              if (
                newTable[index] &&
                newTable[index].is_reserved === 2 &&
                newTable[index].is_split === 1
              ) {
                newTable[index] = { ...newTable[index], is_reserved: 1 };
              } else {
                newTable[index] = { ...newTable[index], is_reserved: 0 };
              }
              selectedTable = {
                ...selectedTable,
                [table.id]: {
                  ...table,
                  ...(table.is_reserved === 2 && table.is_split === 1
                    ? { is_reserved: 1 }
                    : { is_reserved: 0 }),
                },
              };
            }
          });
        setTables(newTable);
        setTableApi(newTable);
        setSelectTable(selectedTable);
      }
    }
  }, [tableForSearch, orderDetails?.branch]);

  // multi select option
  useEffect(() => {
    if (!buttonDisabled && Object.values(selectTable)[0]) {
      setTables(tablesApi);
      setSelectTable({});
      setOrderDetails((curr) => {
        const newData = {
          ...curr,
          table: null,
          waiter: waiterSelected ? waiterSelected : null,
          total_guest: guestSelected ? guestSelected : 1,
          table_id: null,
          table_name: null,
        };
        return newData;
      });
    }
  }, [
    multiSelect,
    tablefloor,
    selectedDeliveryType,
    orderDetails?.branch,
    selectedDeptTag,
    selectedParty,
  ]);

  useEffect(() => {
    // search waiter acc to branch
    // if (orderDetails.branch) {
    //   let tempWaiters =
    //     waiterForSearch !== null &&
    //     waiterForSearch.filter((eachWaiter) => {
    //       return parseInt(eachWaiter.branch_id) === orderDetails?.branch.id;
    //     });
    //   setWaiter(tempWaiters);
    // }

    if (order_id) {
      setWaiterSelected(orderDetails?.waiter ? orderDetails?.waiter : "");
      setGuestSelected(
        orderDetails?.total_guest ? parseInt(orderDetails?.total_guest) : 1
      );
      if (
        history.location?.search?.startsWith("?table_merge=") ||
        (orderDetails.table &&
          orderDetails.table?.length > 0 &&
          orderDetails.table[0].is_merge)
      ) {
        setMultiSelect(true);
      }
    }
  }, [selectedDeliveryType, orderDetails?.branch]);

  //selected tables in state for final playload
  useEffect(() => {
    if(!Object.keys(selectTable || {})?.length) return;
    let tables = Object.values(selectTable);
    // let tableid = Object.keys(selectTable)?.map(id => table_Id.push(parseInt(id)));
    let tableid = Object.keys(selectTable)?.map((id) => parseInt(id));
    setNewTable(tables);
    setTableId(tableid);
  }, [selectTable]);

  const handleTableSubmit = (e) => {
    e.preventDefault();
    const tableValidation =
      selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i) && 
      (parseInt(orderDetails.branch?.table_waiter) || parseInt(getSystemSettings(generalSettings, "table_waiter")) === 1);
    const waiterOd = getSystemSettings(generalSettings, "waiter_order_type")
      ? JSON.parse(getSystemSettings(generalSettings, "waiter_order_type"))
      : null;

    const needsWaiter = waiterOd && waiterOd.length &&
      waiterOd.includes(selectedDeliveryType.id) && !waiterSelected
    if (needsWaiter) {
      toast.error("Please select waiter");
      return false;
    }
    if (tableValidation) {
      if (!Object.keys(selectTable || {}).length) {
        toast.error("Please select the table first");
        return false;
      }

      const tableData = Object.values(selectTable)[0];

      if (tableData.is_reserved && tableData.is_split === 0) {
        toast.error("Table is already reserved");
        return false;
      }
      // setOrderDetails((curr) => ({
      //   ...curr,
      //   table: newtable ? newtable : null,
      //   waiter: waiterSelected ? waiterSelected : null,
      //   total_guest: guestSelected ? guestSelected : 1,
      //   table_id: tableId,
      //   table_name: Object.values(selectTable)[0]?.name,
      // }));
      // setModal10Show(false);
    }
    const tableData = Object.values(selectTable || {})[0];
    setOrderDetails((curr) => ({
      ...curr,
      waiter: waiterSelected ? waiterSelected : null,
      total_guest: guestSelected ? guestSelected : 1,
      table: (newtable && newtable?.length) ? newtable : null,
      table_id: (tableId && tableId?.length) ? tableId : null,
      table_name: tableData?.name || null,
    }));
    setModal10Show(false);
  };

  const handleTableSelect = (table, index) => {
    if (
      selectTable &&
      Object.values(selectTable)[0]?.is_split === 1 &&
      Object.values(selectTable)[0]?.is_reserved === 0
    ) {
      toast.error("Please un split the selected split table");
    } else {
      setTempIndex(index);
      if (Object.keys(selectTable).includes(table.id.toString())) {
        setSelectTable((curr) => {
          const tabel = {
            ...curr,
          };
          delete tabel[table.id];
          return tabel;
        });
      } else {
        if (table.is_split && table.is_reserved) {
          setSelectTable({
            [table.id]: {
              ...table,
              name: table?.name + "-B",
              is_color: "",
              is_merge: 0,
            },
          });
        } else {
          if (table.is_reserved) {
            setSelectTable({
              [table.id]: {
                ...table,
                is_split: 0,
                is_merge: 0,
                is_color: "",
              },
            });
          } else {
            setSelectTable({
              [table.id]: {
                ...table,
                is_split: 0,
                is_reserved: 0,
                is_merge: 0,
                is_color: "",
              },
            });
          }
        }
      }
    }
  };

  // multiple table select
  const handleTableMulitpleSelect = (table, ind) => {
    if (table.is_split === 1 || table.is_reserved) {
      toast.error("You can't select split/reserve table on multiselect");
    } else {
      if (Object.keys(selectTable).includes(table.id.toString())) {
        const newTable = [...tables];
        if (ind !== -1) {
          [newTable[ind]] = [{ ...newTable[ind], is_merge: 0, is_color: "" }];
        }
        setTables(newTable);
        setSelectTable((curr) => {
          const tabel = {
            ...curr,
          };
          delete tabel[table.id];
          return tabel;
        });
      } else {
        // let selectedTable = [table,...Object?.values(selectTable)];
        const newTable = [...tables];
        [newTable[ind]] = [{ ...newTable[ind], is_merge: 1 }];
        setSelectTable((curr) => {
          const mergetabel = {
            ...curr,
            [newTable[ind].id]: {
              ...newTable[ind],
              is_color: colorPallete[0] ?? "",
              is_merge: 1,
              is_reserved: 0,
              is_split: 0,
            },
          };
          return mergetabel;
        });
        setTables(newTable);
      }
    }
  };

  // split table
  const handleSplit = () => {
    if (Object.keys(selectTable)?.length > 0) {
      if (multiSelect === true) {
        toast.error("Please turn off multi select option");
      } else {
        // const index2 = tables.findIndex((table) => Object.values(selectTable)[0].id === (table.id));
        const index2 = tempIndex;
        if (
          tables[index2]?.is_split === 1 &&
          tables[index2]?.is_reserved === 0
        ) {
          if (index2 !== -1) {
            const newTable = [...tables];
            [newTable[index2]] = [{ ...newTable[index2], is_split: 0 }];
            setTables(newTable);
          }
          setSelectTable({});
        } else if (
          tablesApi[index2]?.is_split === 1 &&
          tablesApi[index2]?.is_reserved === 1
        ) {
          toast.error("Already Split");
          setSelectTable({});
        } else if (tables[index2]?.is_reserved === 1) {
          if (
            tables[index2]?.id === Object.values(selectTable)[0]?.id &&
            Object.values(selectTable)[0]?.is_split
          ) {
            if (index2 !== -1) {
              const newTable = [...tables];
              [newTable[index2]] = [{ ...newTable[index2], is_split: 0 }];
              setTables(newTable);
            }
            setSelectTable({});
          } else {
            if (index2 !== -1) {
              const newTable = [...tables];
              [newTable[index2]] = [{ ...newTable[index2], is_split: 1 }];
              setTables(newTable);
            }
            setSelectTable({
              [Object.values(selectTable)[0].id]: {
                ...Object.values(selectTable)[0],
                name: Object.values(selectTable)[0].name + "-B",
                is_color: "",
                is_merge: 0,
                is_split: 1,
                is_reserved: 1,
              },
            });
          }
        } else {
          if (index2 !== -1) {
            const newTable = [...tables];
            [newTable[index2]] = [
              { ...newTable[index2], is_split: 1, is_reserved: 0 },
            ];
            setTables(newTable);
          }
          setSelectTable({
            [Object.values(selectTable)[0].id]: {
              ...Object.values(selectTable)[0],
              name: Object.values(selectTable)[0].name + "-A",
              is_color: "",
              is_merge: 0,
              is_split: 1,
              is_reserved: 0,
            },
          });
        }
      }
    } else {
      toast.error("Please Select Table");
    }
  };

  //waiter search
  const handleSearchWaiter = (e) => {
    const search = e.target.value.toLowerCase();
    if (search?.length) {
      const searchedWaiter =
        waiters.waiterList &&
        waiters.waiterList.filter((waiter) =>
          waiter.name.toLowerCase().includes(search)
        );
      setWaiters({
        ...waiters,
        searchedWaiter: searchedWaiter,
      });
    } else {
      setWaiters({
        ...waiters,
        searchedWaiter: null,
      });
    }
  };

  return {
    order_id,
    generalSettings,
    tableLoading,
    waiters,
    setWaiters,
    waiterSelected,
    setWaiterSelected,
    getTableFloor,
    tablefloor,
    setTableFloor,
    multiSelect,
    setMultiSelect,
    tables,
    setTables,
    tablesApi,
    setTableApi,
    tempIndex,
    setTempIndex,
    startDate,
    setStartDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    newtable,
    setNewTable,
    handleTableSubmit,
    handleTableSelect,
    handleTableMulitpleSelect,
    handleSplit,
    handleSearchWaiter,
    waitersList,
  };
};

export default useTableFunctions;
